import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=396a08e4&"
import script from "./CompanyPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CompanyPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&id=396a08e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports